var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-checkbox-group',{on:{"change":_vm.change},model:{value:(_vm.checkboxs),callback:function ($$v) {_vm.checkboxs=$$v},expression:"checkboxs"}},_vm._l((_vm.dicItems),function(dic){return _c('el-checkbox',{key:dic.value,attrs:{"label":dic.value}},[_vm._v(" "+_vm._s(dic.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }